export default __webpack_public_path__ + "static/media/oj.2280fc3d.svg";